import { useEffect, useState } from 'react';

import { api } from 'services/api';

export function useVehicleTypes(): string[] {
  const [vehicleTypes, setVehicleTypes] = useState<string[]>([]);

  useEffect(() => {
    api
      .get<{ data: string[] }>('/admin/filter-options/vehicle-types')
      .then(({ data }) => {
        setVehicleTypes(data.filter(item => !!item));
      })
      .catch(err => Promise.reject(err.message));
  }, []);

  return vehicleTypes;
}
